import classes from "./MetricCard.module.css";

const MetricCard = ({ interactive = true, isLoading = false, onClick, supportingText, title, value }) => {
	if (isLoading) {
		return (
			<div className={`${classes.card} ${interactive ? "" : classes.cardStatic}`} aria-hidden="true">
				<div className={classes.skeletonLabel} />
				<div className={classes.skeletonValue} />
				{supportingText ? <div className={classes.skeletonSupport} /> : null}
			</div>
		);
	}

	const content = (
		<>
			<span className={classes.title}>{title}</span>
			<span className={classes.value}>{value}</span>
			{supportingText ? <span className={classes.support}>{supportingText}</span> : null}
		</>
	);

	if (!interactive) {
		return <div className={`${classes.card} ${classes.cardStatic}`}>{content}</div>;
	}

	return (
		<button className={classes.card} onClick={onClick} type="button">
			{content}
		</button>
	);
};

export default MetricCard;
